import type { z } from 'zod';

import { createVersionedFeature } from '../create-versioned-feature';
import { shadowSettingsV0Schema, shadowV0Schema } from './v0';

/**
 * The shadow a box casts.
 *
 * Only the **column** casts one, and it is deliberately **flat**: legacy never
 * carried `isShadow` / `shadowSettings` in a per-device bag, no panel offers a
 * device toggle for it, and the CSS emits `--column-shadow` without device
 * twins.
 */
export const shadowFeature = createVersionedFeature({
    versionMap: {
        0: { schema: shadowV0Schema },
    },
    latestVersion: 0,
    createDefault: (): z.output<typeof shadowV0Schema> => ({
        version: 0,
        isEnabled: false,
        settings: null,
    }),
});

export type ShadowFeatureSettings = z.output<typeof shadowFeature.latestSchema>;
export type ShadowValues = z.output<typeof shadowSettingsV0Schema>;

export { shadowV0Schema, shadowSettingsV0Schema };

export { DEFAULT_SHADOW_VALUES, shadowValueVar, shadowVar } from './shadow.css-vars';
